/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi)
 * @export
 * @enum {number}
 */
export enum DispatchAppsEnum {
    /** Uber */
    UBER = 1,
    /** DiDi */
    DIDI = 2
}

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) の Union 型
 * @export
 * @typedef DispatchApps
 */
export type DispatchApps =
  typeof DispatchAppsEnum[keyof typeof DispatchAppsEnum];

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) のラベルマップ
 * @export
 */
export const DispatchAppsLabels = {
    /**
     * 数値キー: DispatchAppsEnum.UBER
     * 名前キー:  UBER
     */
    [DispatchAppsEnum.UBER]: 'Uber',
    UBER:                             'Uber',
    /**
     * 数値キー: DispatchAppsEnum.DIDI
     * 名前キー:  DIDI
     */
    [DispatchAppsEnum.DIDI]: 'DiDi',
    DIDI:                             'DiDi',
} as const;

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) のラベル Union 型
 * @export
 * @typedef DispatchAppsLabel
 */
export type DispatchAppsLabel =
  typeof DispatchAppsLabels[keyof typeof DispatchAppsLabels];

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) のラベル取得関数
 * @export
 * @param { DispatchApps } value - 列挙体の値
 * @returns { DispatchAppsLabel } ラベル文字列
 */
export function getDispatchAppsLabel(
  value: DispatchApps
): DispatchAppsLabel {
  return DispatchAppsLabels[value];
}

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) のラベル配列を取得する関数
 * @export
 * @param { DispatchApps[] } values - 列挙体の値配列
 * @returns { DispatchAppsLabel[] } ラベル文字列配列
 */
export function getDispatchAppsLabels(values: DispatchApps[]): DispatchAppsLabel[] {
  return values.map((value) => getDispatchAppsLabel(value));
}

/**
 * 配車アプリ連携種別 (1:Uber, 2:DiDi) のラベル配列
 * @export
 */
export const DispatchAppsLabelList = [
  'Uber','DiDi',
] as const;

